export function getView(id, external, question_type_id) {
  if (question_type_id === 'custom') return true

  return external && !Object.keys(external).length
}
